import SkillCard from 'entities/SkillCard';

import Iso_2 from 'assets/illustrations/isometrics/2.png';
import Iso_3 from 'assets/illustrations/isometrics/3.png';
import Iso_5 from 'assets/illustrations/isometrics/5.png';
import Iso_1 from 'assets/illustrations/isometrics/1.png';
import UxUi from 'assets/illustrations/isometrics/uxUi.png';
import Stats from 'assets/illustrations/isometrics/stats.png';
import Phone from 'assets/illustrations/isometrics/phone.png';
import Profile from 'assets/illustrations/isometrics/profile.png';
import Workspace from 'assets/illustrations/isometrics/workspace.png';
import MachineLearning from 'assets/illustrations/isometrics/machineLearning.png';

const labels = ['Анализ и управление', 'Разработка', 'Инфраструктура и поддержка'];

const tabsData = {
  [labels[0]]: [
    {
      title: 'Архитектура',
      subTitle: '20+ сотрудников',
      // tags: ['Software Architect', 'Solutions Architect', 'Enterprise Architect'],
      illustration: MachineLearning,
      illustrationProps: {
        w: {
          mobile: '260px',
          xm: '300px',
          tablet: '255px',
          md: '295px',
          laptop: '300px',
          xxls: '430px',
        },
        h: 'auto',
        right: { mobile: '-100px', xm: '-110px', tablet: '-85px', laptop: '-75px', xxls: '-70px' },
        bottom: { mobile: '-25px', xm: '-35px', tablet: '-20px', laptop: '-20px', xxls: '-30px' },
      },
    },
    {
      title: 'Управление проектами',
      subTitle: '50+ сотрудников',
      // tags: ['Project Managers', 'Scrum Masters', 'Project Coordinators'],
      contentContainerProps: { maxW: { mobile: '187px', tablet: 'unset', laptop: '300px' } },
      illustration: Profile,
      illustrationProps: {
        w: {
          mobile: '330px',
          xm: '360px',
          tablet: '350px',
          md: '390px',
          laptop: '315px',
          xxl: '400px',
          xxxl: '500px',
        },
        h: 'auto',
        right: {
          mobile: '-190px',
          xm: '-180px',
          tablet: '-200px',
          laptop: '-110px',
          xxl: '-100px',
          xxxl: '-165px',
        },
        bottom: {
          mobile: '-25px',
          xm: '-40px',
          tablet: '-20px',
          laptop: '0px',
          xxl: '-40px',
          xxxl: '-45px',
        },
      },
    },
    {
      title: 'Обеспечение качества',
      subTitle: '450+ сотрудников',
      // tags: ['Manual', 'Automation', 'Performance'],
      contentContainerProps: { maxW: 'unset' },
      illustration: Workspace,
      illustrationProps: {
        w: { mobile: '320px', tablet: '420px', laptop: '390px', xxl: '475px', xxxl: '550px' },
        h: 'auto',
        right: {
          mobile: '-125px',
          xm: '-115px',
          tablet: '-130px',
          laptop: '-90px',
          xxl: '-100px',
          xxxl: '-130px',
        },
        bottom: { mobile: '-15px', tablet: '-35px', laptop: '-20px', xxl: '-25px', xxxl: '-32px' },
      },
    },
    {
      title: 'Анализ данных',
      subTitle: '350+ сотрудников',
      // tags: ['Business', 'System', 'BI'],
      // tagsContainerProps: { maxW: '220px' },
      contentContainerProps: { maxW: 'unset' },
      illustration: Stats,
      illustrationProps: {
        w: {
          mobile: '320px',
          xm: '370px',
          tablet: '330px',
          md: '390px',
          laptop: '475px',
          xxl: '550px',
          xxxl: '590px',
        },
        h: 'auto',
        right: {
          mobile: '-85px',
          xm: '-95px',
          tablet: '-20px',
          laptop: '-25px',
          xxl: '-45px',
          xxxl: '-35px',
        },
        bottom: { mobile: '-20px', tablet: '20px', laptop: '-20px', xxl: '-40px' },
      },
    },
  ],
  [labels[1]]: [
    {
      title: 'Разработка интерфейсов',
      subTitle: '450+ сотрудников',
      // tags: ['React', 'Angular', 'Vue.js', 'JavaScript'],
      contentContainerProps: { maxW: 'unset' },
      illustration: Iso_2,
      illustrationProps: {
        w: {
          mobile: '230px',
          xm: '250px',
          tablet: '260px',
          md: '315px',
          laptop: '325px',
          xxl: '420px',
          xxxl: '510px',
        },
        h: 'auto',
        right: {
          mobile: '-80px',
          xm: '-50px',
          md: '-117px',
          laptop: '-100px',
          xxl: '-80px',
          xxxl: '-90px',
        },
        bottom: {
          mobile: '-15px',
          xm: '-25px',
          tablet: '-30px',
          md: '8px',
          laptop: '-10px',
          xxl: '-40px',
          xxxl: '-125px',
        },
      },
    },
    {
      title: 'Разработка серверной части',
      subTitle: '350+ сотрудников',
      // tags: ['Java', '.Net', 'Python', 'Golang', 'PHP', 'C++'],
      // tagsContainerProps: { maxW: { mobile: '180px', tablet: 'unset' } },
      contentContainerProps: { maxW: { mobile: '250px', tablet: 'unset' } },
      illustration: Iso_3,
      illustrationProps: {
        w: {
          mobile: '280px',
          xm: '340px',
          tablet: '430px',
          md: '460px',
          laptop: '430px',
          xxl: '510px',
          xxxl: '585px',
        },
        h: 'auto',
        right: {
          mobile: '-100px',
          xm: '-110px',
          tablet: '-180px',
          laptop: '-160px',
          xxl: '-80px',
          xxxl: '-85px',
        },
        bottom: {
          mobile: '-15px',
          xm: '-35px',
          tablet: '-30px',
          laptop: '-25px',
          xxl: '-80px',
          xxxl: '-105px',
        },
      },
    },
    {
      title: 'Разработка мобильных приложений',
      subTitle: '130+ сотрудников',
      // tags: ['Android', 'IOS'],
      contentContainerProps: { maxW: { mobile: '270px', tablet: 'unset' } },
      illustration: Iso_5,
      illustrationProps: {
        w: {
          mobile: '290px',
          tablet: '330px',
          md: '340px',
          laptop: '400px',
          xxl: '490px',
          xxxl: '540px',
        },
        h: 'auto',
        right: { mobile: '-50px', laptop: '-60px', xxl: '-35px', xxxl: '-40px' },
        bottom: { mobile: '-40px', laptop: '-40px', xxl: '-120px', xxxl: '-135px' },
      },
    },
    {
      title: '1C-разработка',
      subTitle: '50+ сотрудников',
      // tags: ['1C ERP 2.0', '1C ZUP Corp', '1C DO Corp', '1C Integration', 'Bitrix 24'],
      // tagsContainerProps: { maxW: { mobile: 'full', md: '150px', xxl: '290px' } },
      contentContainerProps: { maxW: 'unset' },
      illustration: Iso_1,
      illustrationProps: {
        w: {
          mobile: '220px',
          xm: '250px',
          tablet: '290px',
          md: '320px',
          laptop: '400px',
          xxl: '380px',
          xxxl: '430px',
        },
        h: 'auto',
        right: {
          mobile: '-50px',
          xm: '-65px',
          tablet: '-110px',
          md: '-120px',
          laptop: '-150px',
          xxl: '-110px',
          xxxl: '-85px',
        },
        bottom: {
          mobile: '-125px',
          xm: '-140px',
          tablet: '-50px',
          md: '-70px',
          laptop: '-90px',
          xxl: '-180px',
          xxxl: '-165px',
        },
      },
    },
  ],
  [labels[2]]: [
    {
      title: 'Дизайн',
      subTitle: '50+ сотрудников',
      // tags: ['UX Engineers', 'UI Design', 'Graphic Designers', '3D Designers'],
      illustration: UxUi,
      illustrationProps: {
        w: {
          mobile: '240px',
          xm: '255px',
          tablet: '290px',
          md: '310px',
          laptop: '340px',
          xxxl: '410px',
        },
        h: 'auto',
        right: {
          mobile: '-100px',
          xm: '-75px',
          tablet: '-120px',
          md: '-130px',
          laptop: '-140px',
          xxl: '-50px',
          xxxl: '-60px',
        },
        bottom: {
          mobile: '-25px',
          xm: '-30px',
          tablet: '-60px',
          md: '10px',
          laptop: '-65px',
          xxl: '-70px',
          xxxl: '-100px',
        },
      },
    },
    {
      title: 'Инженер по автоматизации разработки и эксплуатации',
      subTitle: '50+ сотрудников',
      // tags: ['DevOps Engineers', 'DevSecOps', 'Cloud Engineers', 'SRE'],
      // tagsContainerProps: { flexDir: { mobile: 'column', laptop: 'row' } },
      contentContainerProps: { maxW: { mobile: '220px', tablet: '300px', laptop: 'unset' } },
      illustration: Phone,
      illustrationProps: {
        w: {
          mobile: '370px',
          xm: '400px',
          tablet: '490px',
          md: '510px',
          laptop: '460px',
          xxl: '650px',
          xxxl: '720px',
        },
        h: 'auto',
        right: { mobile: '-25px', tablet: '-60px', laptop: '-50px', xxl: '-60px' },
        bottom: { mobile: '-35px', tablet: '-5px', laptop: '-40px', xxl: '-55px', xxxl: '-60px' },
      },
    },
  ],
};

export const bodyShopMultiTabsCardsData = {
  title: (
    <>
      Навыки и профессиональная <br /> подготовка наших специалистов
    </>
  ),
  CardComponent: SkillCard,
  labels,
  tabsData,
};
